import { TRAINING_APP_PATH } from 'modules/training/modules/app/constants'
import { getObjectUtil } from 'packages/src'

const isCheckingIosAppSelect = state => {
  return !!getObjectUtil(state, TRAINING_APP_PATH.IS_CHECKING_IOS)
}

export default isCheckingIosAppSelect
